<template>
  <v-flex data-qa="mortgageagreement-flex-sa24wo">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 pt-0" data-qa="mortgageagreement-layout-vedac0u">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient }"
       data-qa="mortgageagreement-flex-5ps8wl">
        <v-container data-qa="mortgageagreement-container-jzh7ve">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="mortgageagreement-flex-z36h5i">
            <v-flex xs12 sm10 md10 lg8 xl7 data-qa="mortgageagreement-flex-k5wlzo">
              <v-row no-gutters class="pb-2" data-qa="mortgageagreement-row-karw4u">
                <v-flex xs2 sm1 md1 lg1 xl1 data-qa="mortgageagreement-flex-vrxuxm">
                  <inline-svg
                    class="mt-2"
                    :src="getNavigationIcon()"
                    width="50"
                    height="50"
                    aria-label="Navigation Icon"
                  ></inline-svg>
                </v-flex>
                <v-flex xs10 sm9 md9 lg9 xl9 class="pt-5" data-qa="mortgageagreement-flex-80y1p8">
                  <font class="headline font-weight-light white--text pl-2">
                    {{ $t("common.mortgageAgreementLabel") }} <font v-if="showTotalAccountsAvailable">({{mortgageAccounts.accounts.length}})</font>
                  </font>
                </v-flex>
                <v-row v-if="showTotalBalance" class="px-2 pl-6 py-2" data-qa="mortgageagreement-row-8qyh3f">
                  <v-layout
                    v-if="mortgageAccounts.accounts && mortgageAccounts.accounts.length"
                    row
                    wrap
                   data-qa="mortgageagreement-layout-4nlp7c">
                    <v-flex xs6 sm6 md6 lg6 xl6 class="px-1" data-qa="mortgageagreement-flex-kl22zb">
                      <font class="subheading-1 font-weight-medium white--text"
                        >{{ $t("accountDetails.totalOutstandingBalance") }}
                      </font>
                    </v-flex>
                    <v-flex xs10 sm10 md10 lg10 xl10 class="px-1" data-qa="mortgageagreement-flex-knrsys">
                      <font class="text-h5 font-weight-bold white--text"
                        >{{ $formatter.currency.format(accDetails.outstandingAmount) }}
                      </font>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-row>
            </v-flex>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg9 xl9 class="pl-1 mt-4" data-qa="mortgageagreement-flex-dfl88">
      <CardLayout :config="mortgageAccounts" />
    </v-flex>
  </v-flex>
</template>

<script>
import event from '@/util/event'
import preload from '@/util/preload'
import store from '@/core/store'
import CardLayout from '@/views/home/HomeCards.vue'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'MortgageAgreementList',
  components: {
    Loader,
    CardLayout
  },
  data () {
    return {
      loaderEnabled: false,
      mortgageAccounts: {
        title: this.$t('common.mortgageAgreementLabel'),
        cardLabels: false,
        openNewACCard: false,
        enableShowMore: false,
        accounts: []
      },
      accDetails: {
        myBalance: 0,
        outstandingAmount: 0,
        series: []
      },
      showTotalBalance: this.$appSettings.defaultConfigurations.totalBalanceSection.enableMortgageSection,
      showTotalAccountsAvailable: this.$appSettings.defaultConfigurations.showTotalAccountsAvailable.enableMortgageSection
    }
  },
  beforeCreate () {
    if (this.$route.params.reload) {
      location.reload()
    }
  },
  created () {
    if (this.$route.params && this.$route.params.from === 'Dashboard') {
      this.mortgageAccounts.enableShowMore = true
    } else this.mortgageAccounts.enableShowMore = false
    event.$on('set_myMortgageAccounts', () => {
      this.getListOfMortgageAccounts()
      this.loaderEnabled = false
    })
    if (this.ifMyAccountsAvailable()) {
      this.getListOfMortgageAccounts()
    } else {
      this.loaderEnabled = true
      preload.getListOfLoanAccounts(
        JSON.parse(sessionStorage.getItem('username'))
      )
      this.loaderEnabled = false
    }
  },
  methods: {
    getNavigationIcon () {
      return this.getSvgIconSrc('Loan_Dashboard')
    },
    ifMyAccountsAvailable () {
      return store.getters['userStore/userData'].mortgageAccounts
    },
    async getListOfMortgageAccounts () {
      this.loaderEnabled = true
      const mortgageAccounts = await store.getters['userStore/userData']
        .mortgageAccounts
      if (mortgageAccounts) {
        this.setMortgageAccounts(mortgageAccounts)
      }
      this.loaderEnabled = false
    },
    setMortgageAccounts (mortgageAgreement) {
      if (mortgageAgreement && mortgageAgreement.length) {
        this.mortgageAccounts.accounts = mortgageAgreement
        this.accDetails.amount = 0
        this.accDetails.outstandingAmount = 0
        for (let i = 0; i < this.mortgageAccounts.accounts.length; i++) { // Mortgage Agreements
          for (const index in this.mortgageAccounts.accounts[i].options) { // Loan Accounts
            this.accDetails.amount += this.mortgageAccounts.accounts[i].options[index].value.amount
            this.accDetails.outstandingAmount +=
              this.mortgageAccounts.accounts[i].options[index].value.amount
          }
        }
      }
    },
    beforeDestroy () {
      event.$off('set_myMortgageAccounts')
    }
  }
}
</script>
